var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    { ref: "scrollContainer", staticClass: "document-automation-card" },
    [
      _c(
        "b-row",
        { staticClass: "mt-lg-0 mt-3" },
        [
          _c(
            "b-col",
            { staticClass: "position-static", attrs: { md: "4", cols: "12" } },
            [
              _c("document-automation-request-title", {
                attrs: {
                  automation: _vm.automation,
                  "toggle-loading": _vm.toggleLoading,
                },
                on: {
                  "toggle-active": _vm.handleToggleActive,
                  "toggle-edit": _vm.handleToggleEdit,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { md: "8", cols: "12" } },
            [
              _c("p", { staticClass: "mb-0" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("automations.documentLevel.belowWillBeRequested")
                    ) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("document-manage", {
                attrs: { automation: _vm.automation },
                on: {
                  "add-document": _vm.handleAddDocument,
                  "edit-document": _vm.handleEditDocument,
                  "delete-document": _vm.handleDeleteDocument,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }